var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManipalBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 635,
    height: 179,
    viewBox: "0 0 635 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.714 87.295L43.1777 0H166.861L257.186 87.295L166.861 178.558H43.1777L141.714 87.295Z",
    fill: "#FEFEFE",
    fillOpacity: 0.72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5364 87.295L0 0H123.684L214.009 87.295L123.684 178.558H0L98.5364 87.295Z",
    fill: "#F25F29",
    fillOpacity: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M518.714 87.295L420.178 0H543.861L634.186 87.295L543.861 178.558H420.178L518.714 87.295Z",
    fill: "#F25F29",
    fillOpacity: 0.02
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M475.536 87.295L377 0H500.684L591.009 87.295L500.684 178.558H377L475.536 87.295Z",
    fill: "#F25F29",
    fillOpacity: 0.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManipalBanner);
export default __webpack_public_path__ + "static/media/manipal-banner.5a18234cca64320c014f17d07740c03f.svg";
export { ForwardRef as ReactComponent };